import { render, staticRenderFns } from "./view-faq.vue?vue&type=template&id=16ce9fb6&scoped=true&"
import script from "./view-faq.vue?vue&type=script&lang=js&"
export * from "./view-faq.vue?vue&type=script&lang=js&"
import style0 from "./view-faq.vue?vue&type=style&index=0&id=16ce9fb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ce9fb6",
  null
  
)

export default component.exports